module.exports = __webpack_public_path__ + "static/wilmaa_web_tv_thumb-acd28075687fdb72fa1960997cf78b24.jpg";